import {Box, Notification, Text} from "@mantine/core";
import {StepIcon} from "@/protocols/common/StepIcon.tsx";
import {IProtocolStep} from "@/protocols/types/protocol.ts";
import cx from "clsx";
import classes from "../FocusModeView.module.css";

interface UpNextNotificationProps {
    nextStep: IProtocolStep | undefined;
}

/**
 * Shows a notification preview of the next step.
 */
export const UpNextNotification: React.FC<UpNextNotificationProps> = ({
    nextStep,
}) => {
    if (!nextStep) {
        return <Box/>;
    }

    return (
        <Box className={cx(classes.upNextWrapper)}>
            <Notification
                variant={"unstyled"}
                color={"var(--bios-medium-blue-9)"}
                icon={<StepIcon kind={nextStep.kind}/>}
                title={<Text>Up Next</Text>}
                withCloseButton={false}
                withBorder={true}
                style={{borderColor: "var(--bios-medium-blue-9)"}}
            >
                <Text>{nextStep.name}</Text>
            </Notification>
        </Box>
    );
};
